import template from './textEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor($mdDialog, $mdMedia, eventService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.destroyWatch = eventService.onDialogTextEdit(function (_params) {
          $mdDialog
            .show({
              targetEvent: _params.event,
              locals: {
                icon: _params.icon || 'create',
                title: _params.title,
                fieldTitle: _params.fieldTitle || 'Text',
                content: _params.content,
                mergeProperties: _params.mergeProperties,
                plainText: _params.plainText
              },
              template,
              controllerAs: '$ctrl',
              controller: dialogController
            })
            .then(function (content) {
              if (ctrl.onFinished) {
                ctrl.onFinished({ result: { id: _params.id, content: content } });
              }
            });

          function dialogController(
            $mdDialog,
            icon,
            title,
            fieldTitle,
            content,
            mergeProperties,
            plainText
          ) {
            this.icon = icon;
            this.title = title;
            this.fieldTitle = fieldTitle;
            this.content = content;
            this.plainText = plainText;
            this.mergeProperties = mergeProperties;
            if (this.mergeProperties && this.mergeProperties.length) {
              this.plainText = true;
            }
            this.addPropertyCode = function (binding, property) {
              eventService.inputInsertValue(binding, '{' + property.key + '}');
            };
            this.confirm = function () {
              $mdDialog.hide(this.content);
            };
            this.cancel = function () {
              $mdDialog.cancel();
            };
          }
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
